import { toast } from '@gitbook/spine-react';

import { apiClient } from '../../state';

/**
 * Stop an import, reporting how it went.
 */
export function cancelImportRunWithToast(organizationId: string, runId: string): void {
    toast.promise(apiClient.imports.cancelImportRun(organizationId, runId), {
        loading: 'Stopping import…',
        success: 'Import stopped',
    });
}
